import React from 'react';
import Head from 'next/head';

type Props = {
  title: string; // title tag only accepts string (TS doesn't catch wrong type in title tag, only visible in browser UI)
  description?: string;
};

/**
 * Sets page's title and description in HTML header:
 * - meta title gives a user a concise and comprehensible impression of what the page is about
 * - meta description describes and summarizes the content of the page (without dynamic values dependent on endpoint response)
 *
 * @returns Page Meta component
 */
const PageMeta = ({ title, description }: Props) => (
  <Head>
    <title key="title">{title}</title>
    {description && <meta name="description" content={description} />}
  </Head>
);

export default PageMeta;
